import { z } from "zod";
import { inviteCodeSchema } from "./auth";

export const createInviteSchema = z.object({
  /** Leave empty to let the server mint a code. */
  code: inviteCodeSchema.optional(),
  email: z.string().email().optional(),
  note: z.string().max(200).optional(),
  maxUses: z.number().int().min(1).max(1000).default(1),
  /** Days until the code stops working. Omit for no expiry. */
  expiresInDays: z.number().int().min(1).max(365).optional(),
});

export const adjustCreditsSchema = z.object({
  /** Positive to grant, negative to claw back. */
  amount: z
    .number()
    .int()
    .min(-1_000_000)
    .max(1_000_000)
    .refine((n) => n !== 0, { message: "Amount must not be zero" })
    .refine((n) => n !== 0, "Amount cannot be zero"),
  reason: z.string().min(3).max(200),
});

export type CreateInviteInput = z.infer<typeof createInviteSchema>;
export type AdjustCreditsInput = z.infer<typeof adjustCreditsSchema>;
